export function dxfFloat(f) {
    //  return Math.round(parseFloat(f));
    return Math.round(parseFloat(f) * 100) / 100;
}
export function areFloatsEqual(float1, float2, tolerance = 0.0001) {
    return Math.abs(float1 - float2) < tolerance;
}
